// extracted by mini-css-extract-plugin
var _1 = "DeleteStep_content__o0ybn";
var _2 = "DeleteStep_deleteButton__lYVhl";
export { _1 as "content", _2 as "deleteButton" }
